import ImmediateScript from "./ImmediateScript";

export default ImmediateScript;
